import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-video-call-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-call-widget.component.html',
  styleUrls: ['./video-call-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoCallWidgetComponent {}
